import BioEntryContextProvider from '../../state/bioEntry/BioEntryContextProvider';
import NTContactsContextProvider from '../../state/nationalTeamContacts/NTContactsContextProvider';
import NTAttachmentContextProvider from '../../state/nationalTeamAttachment/NTAttachmentContextProvider';
import PersonProfileContextProvider from '../../state/personProfile/PersonProfileContextProvider';
import PersonNationalTeamContextProvider from '../../state/personNationalTeam/PersonNationalTeamContextProvider';
import PersonCoursesForAdminRoleContextProvider from '../../state/member/memberAdminCourses/PersonCoursesForAdminRoleContextProvider';
import PersonNationalTeamFileTypeContextProvider from '../../state/personNationalTeamFileType/PersonNationalTeamFileTypeContextProvider';

import UserContextProvider from '@usas/ui-web/state/lmsUser/UserContextProvider';
import CommentContextProvider from '@usas/ui-web/state/comment/CommentContextProvider';
import BasePersonContextProvider from '@usas/ui-web/state/personBase/BasePersonContextProvider';
import EnrollmentContextProvider from '@usas/ui-web/state/lmsEnrollment/EnrollmentContextProvider';
import PersonGeneralContextProvider from '@usas/ui-web/state/personGeneral/PersonGeneralContextProvider';
import GenderIdentityTypeContextProvider from '@usas/ui-web/state/genderIdentity/GenderIdentityTypeContextProvider';
import ContactRelationshipTypesContextProvider from '@usas/ui-web/state/contactRelationshipType/ContactRelationshipTypesContextProvider';
import EnrollmentInCertificationContextProvider from '@usas/ui-web/state/lmsEnrollment/EnrollmentInCertificationContextProvider';
import CoachEnrollmentInCertificationContextProvider from '@usas/ui-web/state/lmsEnrollment/CoachEnrollmentInCertificationContextProvider';

const MemberContextRoutesProviders = ({ children }) => {
  return (
    <BasePersonContextProvider>
      <PersonGeneralContextProvider>
        <BioEntryContextProvider>
          <NTContactsContextProvider>
            <NTAttachmentContextProvider>
              <CommentContextProvider>
                <PersonProfileContextProvider>
                  <PersonNationalTeamContextProvider>
                    <PersonNationalTeamFileTypeContextProvider>
                      <ContactRelationshipTypesContextProvider>
                        <GenderIdentityTypeContextProvider>
                          <EnrollmentContextProvider>
                            <EnrollmentInCertificationContextProvider>
                              <CoachEnrollmentInCertificationContextProvider>
                                <PersonCoursesForAdminRoleContextProvider>
                                  <UserContextProvider>
                                    {children}
                                  </UserContextProvider>
                                </PersonCoursesForAdminRoleContextProvider>
                              </CoachEnrollmentInCertificationContextProvider>
                            </EnrollmentInCertificationContextProvider>
                          </EnrollmentContextProvider>
                        </GenderIdentityTypeContextProvider>
                      </ContactRelationshipTypesContextProvider>
                    </PersonNationalTeamFileTypeContextProvider>
                  </PersonNationalTeamContextProvider>
                </PersonProfileContextProvider>
              </CommentContextProvider>
            </NTAttachmentContextProvider>
          </NTContactsContextProvider>
        </BioEntryContextProvider>
      </PersonGeneralContextProvider>
    </BasePersonContextProvider>
  );
};

export default MemberContextRoutesProviders;